"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isClickOutside = void 0;

/**
 * Handler for checking if the click was outside of a node.
 * @param event
 * @param node - the react node to be checked.
 * @param ignoreClasses - array of classNames to be ignored on check.
 * @returns {*|boolean}
 */
var isClickOutside = function isClickOutside(event, node) {
  var ignoreClasses = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  // event.target.path is available only in chrome, firefox alternative is event.composedPath()
  var path = event.target.path || event.composedPath && event.composedPath();
  var isInsideModal = path && path.findIndex && path.findIndex(function (p) {
    return ignoreClasses.indexOf(p.className) !== -1;
  }) !== -1;
  return node && !node.contains(event.target) && !isInsideModal;
};

exports.isClickOutside = isClickOutside;
//# sourceMappingURL=is-click-outside.js.map